"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const fa_1 = require("react-icons/fa");
const styles_1 = require("./styles");
var ButtonSize;
(function (ButtonSize) {
    ButtonSize["large"] = "btn-lg";
    ButtonSize["normal"] = "btn-md";
    ButtonSize["small"] = "btn-sm";
    ButtonSize["mini"] = "btn-xs";
})(ButtonSize || (ButtonSize = {}));
exports.Button = ({ type = "default", size = "normal", submit, outline, block, borderless, title, disabled, icon, iconRight, usesLoading, loadingText, onClick, className, }) => {
    const [loading, setLoading] = react_1.useState(false);
    var classes = classnames_1.default("btn", { [`btn-${type}`]: !outline }, { [`btn-outline-${type}`]: outline }, { "btn-block": block }, { "btn-borderless": borderless }, ButtonSize[size], className);
    const handleOnClick = async (e) => {
        e.preventDefault();
        if (usesLoading)
            setLoading(true);
        await onClick();
        if (usesLoading)
            setLoading(false);
    };
    return (react_1.default.createElement(styles_1.Container, { type: submit ? "submit" : "button", className: classes, onClick: handleOnClick, disabled: disabled || loading },
        react_1.default.createElement(styles_1.Content, null,
            usesLoading && loading && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(styles_1.Icon, null,
                    react_1.default.createElement(fa_1.FaSpinner, { className: 'fa-pulse' })),
                react_1.default.createElement(styles_1.Text, { className: "btn-text" }, loadingText))),
            !loading && (react_1.default.createElement(react_1.default.Fragment, null,
                icon && !iconRight && react_1.default.createElement(styles_1.Icon, { iconRight: iconRight }, icon),
                !loading && title && react_1.default.createElement(styles_1.Text, { className: "btn-text" }, title),
                icon && iconRight && react_1.default.createElement(styles_1.Icon, { iconRight: iconRight }, icon))))));
};
